var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"TextButton",attrs:{"dark":"","elevation":"0","color":_vm.IconBackgroundColor},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }